export const campaignAnalysisReportPdfStyles = `
  @page {
    margin: 8mm 0 10mm;
  }

  html,
  body {
    width: 100%;
    min-width: 0;
    margin: 0;
    background: #ffffff;
    color: #11100e;
    font-size: 13px;
  }

  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body > div,
  [data-campaign-analysis-print-root] {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    margin: 0 !important;
  }

  [data-campaign-analysis-print-root] {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  [data-campaign-analysis-print-root] * {
    min-width: 0 !important;
  }

  [data-campaign-analysis-report-header] {
    padding: 5mm 10mm 9mm !important;
    break-after: avoid-page;
    page-break-after: avoid;
  }

  [data-campaign-analysis-report-title-block] {
    gap: 6.5mm !important;
    margin-bottom: 12mm !important;
  }

  [data-campaign-analysis-report-title] {
    max-width: 190mm !important;
    font-size: 24px !important;
    line-height: 1.2 !important;
  }

  [data-campaign-analysis-report-actions],
  [data-campaign-analysis-screen-nav] {
    display: none !important;
  }

  [data-campaign-analysis-print-section] {
    border-bottom: 0 !important;
    gap: 5mm !important;
    padding: 5mm 10mm !important;
  }

  #executive-summary {
    break-before: auto !important;
    page-break-before: auto !important;
    gap: 6mm !important;
    padding: 5mm 10mm 8mm !important;
  }

  #executive-summary [data-campaign-analysis-print-avoid-break] {
    gap: 4mm !important;
    padding: 4mm !important;
  }

  #executive-summary [data-campaign-analysis-print-section-heading] {
    margin: 0 !important;
  }

  [data-campaign-analysis-print-section]:not(#executive-summary) {
    break-before: page;
    page-break-before: always;
  }

  [data-campaign-analysis-print-section-heading] {
    break-after: avoid;
    page-break-after: avoid;
  }

  [data-campaign-analysis-print-section-heading] h3 {
    font-size: 20px !important;
    line-height: 1.2 !important;
  }

  [data-campaign-analysis-print-section-heading] p {
    font-size: 12px !important;
    line-height: 1.35 !important;
  }

  [data-campaign-analysis-print-avoid-break],
  [data-campaign-analysis-print-root] [data-slot='card'],
  [data-campaign-analysis-print-root] [data-slot='table-row'] {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  [data-campaign-analysis-top-video-header] {
    grid-template-columns: minmax(0, 1fr) 45mm !important;
    align-items: start !important;
  }

  [data-campaign-analysis-top-video-stats] {
    flex-wrap: nowrap !important;
    justify-content: flex-end !important;
    padding-left: 0 !important;
  }

  [data-campaign-analysis-insight-mobile-list] {
    display: none !important;
  }

  [data-campaign-analysis-insight-table] {
    display: block !important;
  }

  [data-campaign-analysis-insight-table-row] {
    grid-template-columns: 48mm 34mm 18mm minmax(0, 1fr) !important;
    column-gap: 3mm !important;
  }

  [data-campaign-analysis-content-guide-item] {
    grid-template-columns: 8mm minmax(0, 1fr) !important;
    align-items: start !important;
    column-gap: 4mm !important;
  }

  [data-campaign-analysis-performance-chart-svg] text {
    font-size: 5px !important;
    line-height: 1 !important;
    font-weight: 400 !important;
  }

  [data-campaign-analysis-performance-chart-tick] {
    font-size: 5px !important;
  }

  [data-campaign-analysis-performance-chart-axis-label] {
    font-size: 6px !important;
    font-weight: 500 !important;
  }

  [data-campaign-analysis-performance-chart-frame] {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  [data-campaign-analysis-print-root] [data-slot='card'] {
    box-shadow: none !important;
  }

  [data-campaign-analysis-print-root] .shadow-sm,
  [data-campaign-analysis-print-root] .shadow,
  [data-campaign-analysis-print-root] .shadow-md {
    box-shadow: none !important;
  }

  [data-campaign-analysis-print-root] [data-slot='card-content'] {
    padding: 0 !important;
  }

  [data-campaign-analysis-print-root] [data-slot='table-container'] {
    overflow: visible !important;
  }

  [data-campaign-analysis-summary-link-icon],
  [data-campaign-analysis-screen-insight-details] {
    display: none !important;
  }

  button {
    display: none !important;
  }

  button[data-campaign-analysis-print-insight-trigger] {
    display: flex !important;
    pointer-events: none !important;
  }

  [data-campaign-analysis-print-insight-toggle] {
    display: none !important;
  }

  [data-campaign-analysis-print-insight-details] {
    display: block !important;
  }

  [data-campaign-analysis-print-root] a {
    color: inherit;
    cursor: default;
    text-decoration: none;
  }

  [data-campaign-analysis-print-root] a *,
  [data-campaign-analysis-print-root] a:hover,
  [data-campaign-analysis-print-root] a:hover * {
    text-decoration: none !important;
  }

  [data-campaign-analysis-print-root] img {
    max-width: 100%;
  }

  [data-campaign-analysis-print-root] .rounded-2xl,
  [data-campaign-analysis-print-root] .rounded-xl {
    border-radius: 8px !important;
  }

  [data-campaign-analysis-print-root] .p-8 {
    padding: 5mm !important;
  }

  [data-campaign-analysis-print-root] .p-6,
  [data-campaign-analysis-print-root] .sm\\:p-6 {
    padding: 4mm !important;
  }

  [data-campaign-analysis-print-root] .p-5,
  [data-campaign-analysis-print-root] .sm\\:p-5 {
    padding: 3.5mm !important;
  }

  [data-campaign-analysis-print-root] .gap-10 {
    gap: 6mm !important;
  }

  [data-campaign-analysis-print-root] .gap-8 {
    gap: 5mm !important;
  }

  [data-campaign-analysis-print-root] .gap-6 {
    gap: 4mm !important;
  }

  [data-campaign-analysis-print-root] .text-3xl {
    font-size: 24px !important;
    line-height: 1.2 !important;
  }

  [data-campaign-analysis-print-root] .text-2xl {
    font-size: 20px !important;
    line-height: 1.2 !important;
  }

  [data-campaign-analysis-print-root] .text-xl {
    font-size: 17px !important;
    line-height: 1.25 !important;
  }

  [data-campaign-analysis-print-root] .text-lg {
    font-size: 15px !important;
    line-height: 1.3 !important;
  }

  [data-campaign-analysis-print-root] .text-base {
    font-size: 13px !important;
    line-height: 1.4 !important;
  }

  [data-campaign-analysis-print-root] .text-sm {
    font-size: 11px !important;
    line-height: 1.45 !important;
  }

  [data-campaign-analysis-print-root] .text-xs {
    font-size: 10px !important;
    line-height: 1.35 !important;
  }
`;
